import { ReactChildren } from "../../../services/model/types";
import { Text, MantineFontSize } from "@mantine/core";

type InputProps = {
  color: string;
  textColor: string;
  className?: string;
  textSize?: MantineFontSize;
  size?: number | string;
  padding?: number | string;
};

export function MyRoundedBadge(props: ReactChildren & InputProps) {
  const { children, color, textColor, className, textSize, size } = props;
  return (
    <div className={className}>
      <div
        style={{
          zIndex: 999,
          backgroundColor: color,
          width: size || 60,
          height: size || 60,
          opacity: 0.93,
        }}
        className="p-4 rounded-full flex justify-center items-center"
      >
        <Text color={textColor} size={textSize} className="font-bold">
          {children}
        </Text>
      </div>
    </div>
  );
}
